<main class="mt-3">
  <kl-bulk-members-addition (loginIdsList)="addMembers($event)"></kl-bulk-members-addition>
</main>
